import React from 'react';
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import './index.css';
import HomePageView from './components/home/home-page-view.js';
import MenuTopView from './components/menu-top-view.js';
import DashboardView from './components/dashboard/dashboard-view.js';
import ErrorView from './components/error-view.js';
import PlanetView from './components/planet-view.js';
import GalaxyBrowserView from "./components/galaxy-browser-view.js";
import PlayerProfileView from "./components/player-profile-view.js";
import GpsDebugView from "./components/gps-debug-view.js";
import RankingView from "./components/ranking-view.js";
import ShipDesignsOverview from "./components/ship-designs-overview.js";
import ShipDesignView from "./components/ship-design-view.js";
import FleetOverview from "./components/fleet/fleet-overview.js";
import FleetView from "./components/fleet/fleet-view.js";
import FleetTransferView from "./components/fleet/fleet-transfer-view.js";
import ChatOverview from "./components/chat-overview.js";
import QuestView from "./components/quest-view.js";
import ChangeLogView from "./components/change-log-view.js";
import ChatView from "./components/chat-view.js";
import BuildingInfoView from "./components/building-info-view.js";
import ResearchView from "./components/research-view.js";
import ToastView from './components/toast-view.js';
import ArcView from "./components/arc/arc-view.js";
import HqView from "./components/hq/hq.js";
import InventoryView from "./components/hq/inventory-view.js";
import DebugView from "./components/debug-view.js";
import * as Backend from './backend.js';
import * as util from './other/util.js';
import ChatComposeView from "./components/chat-compose-view.js";
import shared from "./share/shared.js";
import config from './config.js';

class TopLevelComponent extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = { error: false };

        // This is to handle async errors, from callbacks in the backend (server replies)
        Backend.changeDisplayedPage.callback = (error) => {
            this.setState({ error: true, error_reason: error });
        };
    }

    // This is to handle synchronous errors, during normal render() calls
    static getDerivedStateFromError(error) {
        return { error: true, error_reason: error };
    }

    componentDidCatch(error, errorInfo) {
        console.log("componentDidCatch: " + error)
        console.log("componentDidCatch: " + errorInfo)
    }

    render() {
        if (this.state.error) {
            let error = this.state.error_reason;
            return (<ErrorView {...this.props} error={error} />)
        }

        return (
            <div>
                <Routes>
                    <Route exact path="/game/*" element={<GameWrapperComponent />} />
                    <Route exact path="/change-log/*" element={<ChangeLogView />} />
                    <Route path="*" element={<HomePageView />} />
                </Routes>
                <ToastView content={this.state.toast_content} />
            </div>
        );
    }
}

class GameWrapperComponent extends React.Component {
    render() {
        return (
            <div className="game-wrapper">
                <div className="game-wrapper-sticky-top-menu">
                    <MenuTopView />
                </div>
                <div className="game-wrapper-main-content">
                    <Routes>
                        <Route path="/dashboard" exact element={<DashboardView />} />
                        <Route path="/planet-construction/:x/:y/:z" exact element={<PlanetView activeTab={"planet-construction"} />} />
                        <Route path="/planet-overview/:x/:y/:z" exact element={<PlanetView activeTab={"planet-overview"} />} />
                        <Route path="/planet-research/:x/:y/:z" exact element={<PlanetView activeTab={"planet-research"} />} />
                        <Route path="/planet-research/:x/:y/:z/:technology" exact element={<PlanetView activeTab={"planet-research"} />} />
                        <Route path="/planet-ship-construction/:x/:y/:z" exact element={<PlanetView activeTab={"planet-ship-construction"} />} />
                        <Route path="/planet-ship-design/:x/:y/:z" exact element={<PlanetView activeTab={"planet-ship-design"} />} />
                        <Route path="/planet-ships/:x/:y/:z" exact element={<PlanetView activeTab={"planet-ships"} />} />
                        <Route path="/planet-resources/:x/:y/:z" exact element={<PlanetView activeTab={"planet-resources"} />} />
                        <Route path="/planet-defence/:x/:y/:z" exact element={<PlanetView activeTab={"planet-defence"} />} />
                        <Route path="/planet-debug/:x/:y/:z" exact element={<PlanetView activeTab={"planet-debug"} />} />
                        <Route path="/galaxy-browser/:x/:y/:z" exact element={<GalaxyBrowserView />} />
                        <Route path="/ship-design-overview" exact element={<ShipDesignsOverview />} />
                        <Route path="/ship-design/:id" exact element={<ShipDesignView />} />
                        <Route path="/fleet-overview" exact element={<FleetOverview />} />
                        <Route path="/fleet/:fleet_id" exact element={<FleetView />} />
                        <Route path="/fleet-transfer/:fleet_a_id/:fleet_b_id" exact element={<FleetTransferView />} />
                        <Route path="/player-abstract/:id" exact element={<PlayerProfileView />} />
                        <Route path="/ranking/:ranking_type" exact element={<RankingView />} />
                        <Route path="/arc" exact element={<ArcView />} />
                        <Route path="/hq" exact element={<HqView />} />
                        <Route path="/hq/inventory-view" exact element={<InventoryView />} />
                        <Route path="/gps-debug" exact element={<GpsDebugView />} />
                        <Route path="/quests/:quest_id" exact element={<QuestView />} />
                        <Route path="/research" exact element={<ResearchView />} />
                        <Route path="/chat-overview" exact element={<ChatOverview />} />
                        <Route path="/chat/:chat_id" exact element={<ChatView />} />
                        <Route path="/chat-compose/:player_id" exact element={<ChatComposeView />} />
                        <Route path="/chat-compose" exact element={<ChatComposeView />} />
                        <Route path="/building-info/:building_id" exact element={<BuildingInfoView />} />
                        <Route path="/debug" exact element={<DebugView />} />
                        <Route path="/*" exact element={<div><span>404, soz. Please use this portal to go </span><Link className="link-button" to={{ pathname: '/game/dashboard', force_update: true }}>home</Link>!</div>} />
                    </Routes>
                </div>
            </div>
        );
    }
}

async function autoLogin() {
    if (!config.auto_login) {
        return;
    }
    console.log("Trying auto login ...");
    let has_logged_in = false;
    Backend.tryLogin("alex", shared.secureHash("asd"), (res) => {
        if (!res.success) {
            alert("Auto login failed!");
        }
        console.log("Auto login successful");
        has_logged_in = true;
    });

    while (!has_logged_in) {
        await util.sleep(10);
    }
}

async function main() {

    await autoLogin();

    const container = document.getElementById('root');
    const root = createRoot(container);
    root.render(
        <BrowserRouter>
            <div>
                <TopLevelComponent />
            </div>
        </BrowserRouter>);
}

main();
